const SHEET_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR5G9VHjCy7TllLcq1rdTjzAfcTPJoIzQv5oXDJHBR5ZfHcWm0FCOowolB6bL0XN9CNbW4fzor7LGyo/pub?gid=1559877520&single=true&output=csv';
const PRODUCTS_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR5G9VHjCy7TllLcq1rdTjzAfcTPJoIzQv5oXDJHBR5ZfHcWm0FCOowolB6bL0XN9CNbW4fzor7LGyo/pub?gid=0&single=true&output=csv';

let batchData = [];
let productsData = [];
let isDataLoaded = false;
let currentMatch = null;
let currentProductName = '';
let pendingBatchSearch = null; // Store batch code from URL for auto-search after data loads

// 10 colors for gradient (each used for 2 adjacent bars = 20 bars total)
// Green → Yellow → Orange → Red
const gradientColors = [
  '#22c55e', // Green
  '#65a30d', // Lime-green
  '#84cc16', // Lime
  '#bef264', // Light lime
  '#facc15', // Yellow
  '#fbbf24', // Amber
  '#f59e0b', // Orange-yellow
  '#f97316', // Orange
  '#ef4444', // Red
  '#dc2626'  // Dark red
];

// ==========================================
// STORAGE INITIALIZATION (NON-BLOCKING)
// ==========================================

// Initialize storage in background - never blocks the main app
function initializeStorage() {
  try {
    console.log('Initializing storage...');
    console.log('Customer logged in:', window.IS_CUSTOMER_LOGGED_IN);
    console.log('Customer email:', window.CUSTOMER_EMAIL ? '[EMAIL SET]' : 'null');
    
    // Start storage initialization in background (fire and forget)
    if (window.StorageAdapter) {
      window.StorageAdapter.initialize(window.CUSTOMER_EMAIL);
    } else {
      console.warn('StorageAdapter not available');
    }
  } catch (error) {
    console.error('Error initializing storage:', error);
    // Don't let storage errors break the batch checker
  }
}

// ==========================================
// END STORAGE INITIALIZATION
// ==========================================

function parseCSV(text) {
  const rows = [];
  let row = [];
  let cell = '';
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (char === '"' && !inQuotes) {
      inQuotes = true;
    } else if (char === '"' && inQuotes) {
      if (text[i + 1] === '"') {
        cell += '"';
        i++;
      } else {
        inQuotes = false;
      }
    } else if (char === ',' && !inQuotes) {
      row.push(cell.trim());
      cell = '';
    } else if ((char === '\n' || char === '\r') && !inQuotes) {
      if (char === '\r' && text[i + 1] === '\n') i++;
      row.push(cell.trim());
      if (row.length > 0) rows.push(row);
      row = [];
      cell = '';
    } else {
      cell += char;
    }
  }
  if (cell) row.push(cell.trim());
  if (row.length > 0) rows.push(row);
  return rows;
}

async function loadBatchData() {
  console.log('=== loadBatchData() started ===');
  
  const loadingMsg = document.getElementById('loading-msg');
  const dataWarning = document.getElementById('data-warning');
  
  if (!loadingMsg || !dataWarning) {
    console.error('✗ Loading message or data warning elements not found!');
    return;
  }
  
  loadingMsg.style.display = 'block';
  console.log('Loading message shown, fetching from:', SHEET_CSV_URL);

  try {
    console.log('Fetching Google Sheets CSV...');
    const response = await fetch(SHEET_CSV_URL);
    console.log('Fetch response received:', response.status, response.statusText);
    
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    
    const text = await response.text();
    console.log('CSV text received, length:', text.length);
    
    const rows = parseCSV(text);
    console.log('CSV parsed, rows:', rows.length);
    
    batchData = rows.slice(1);
    console.log('✓ Batch data loaded:', { rowCount: batchData.length, sampleRows: batchData.slice(0, 3) });
    
    isDataLoaded = true;
    loadingMsg.style.display = 'none';
    if (batchData.length === 0 || batchData.every(row => !row[0])) {
      dataWarning.style.display = 'block';
    }
    populateRecentBatches();
    
    // Trigger auto-search if batch parameter was in URL
    if (pendingBatchSearch) {
      console.log('✓ Data loaded! Auto-searching for batch:', pendingBatchSearch);
      const batchInput = document.getElementById('batch-code-input');
      if (batchInput) {
        batchInput.value = pendingBatchSearch;
        console.log('✓ Search input filled, triggering handleBatchSearch()');
        handleBatchSearch();
        pendingBatchSearch = null; // Clear after searching
      } else {
        console.error('✗ Batch input element not found!');
      }
    }
  } catch (err) {
    console.error('Failed to load batch data:', err);
    loadingMsg.style.display = 'none';
    dataWarning.innerHTML = 'Failed to load data from Google Sheets. Check console for details.';
    dataWarning.style.display = 'block';
    dataWarning.className = 'error-message';
    populateRecentBatches();
  }
}

function populateRecentBatches() {
  let orderedProducts = [];
  let seen = new Set();
  for (let row of batchData) {
    let prod = row[1];
    if (prod && !seen.has(prod)) {
      seen.add(prod);
      orderedProducts.push(prod);
    }
  }

  let productLatest = new Map();
  for (let i = batchData.length - 1; i >= 0; i--) {
    let prod = batchData[i][1];
    let batch = batchData[i][0];
    let coa = batchData[i][3];
    if (prod && batch && !productLatest.has(prod)) {
      productLatest.set(prod, {batch: batch, coa: coa});
    }
  }

  let tbody = document.getElementById('recent-table-body');
  if (!tbody) {
    console.error('Recent table body element not found');
    return;
  }
  tbody.innerHTML = '';
  for (let prod of orderedProducts) {
    let info = productLatest.get(prod);
    if (info) {
      let tr = document.createElement('tr');
      let td1 = document.createElement('td');
      td1.textContent = prod;
      let td2 = document.createElement('td');
      let a2 = document.createElement('a');
      a2.href = '#';
      a2.style.color = '#e3fc02';
      a2.style.textDecoration = 'none';
      let hyphenIndex = info.batch.indexOf('-');
      let maskedBatch;
      if (hyphenIndex !== -1) {
        let prefix = info.batch.substring(0, hyphenIndex);
        let suffix = info.batch.substring(hyphenIndex);
        maskedBatch = prefix + suffix.replace(/[^-]/g, '*');
      } else {
        maskedBatch = '*'.repeat(info.batch.length);
      }
      a2.textContent = maskedBatch + ' ↗';
      a2.onclick = function() {
        document.getElementById('batch-code-input').value = info.batch;
        handleBatchSearch();
        return false;
      };
      td2.appendChild(a2);
      tr.appendChild(td1);
      tr.appendChild(td2);
      tbody.appendChild(tr);
    }
  }

  if (orderedProducts.length === 0) {
    let tr = document.createElement('tr');
    let td = document.createElement('td');
    td.colSpan = 2;
    td.textContent = 'No recent batches available.';
    td.style.textAlign = 'center';
    tr.appendChild(td);
    tbody.appendChild(tr);
  }

  document.getElementById('recent-batches').style.display = 'block';
}

async function loadProductsData() {
  try {
    const response = await fetch(PRODUCTS_CSV_URL);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const text = await response.text();
    const rows = parseCSV(text);
    productsData = rows.slice(1);
    console.log('Parsed products data:', { rowCount: productsData.length, sampleRows: productsData.slice(0, 3) });
  } catch (err) {
    console.error('Failed to load products data:', err);
  }
}

// Top Tabs
const tabBatches = document.getElementById('tab-batches');
const tabProducts = document.getElementById('tab-products');
const contentBatches = document.getElementById('batches');
const contentProducts = document.getElementById('products');

tabProducts.addEventListener('click', async () => {
  tabProducts.classList.add('active');
  tabBatches.classList.remove('active');
  contentProducts.classList.add('active');
  contentBatches.classList.remove('active');
  // Ensure data is loaded before rendering stock tracker
  if (typeof renderStockTracker === 'function') {
    // Make sure both datasets are loaded
    if (!batchData || batchData.length === 0) {
      await loadBatchData();
    }
    if (!productsData || productsData.length === 0) {
      await loadProductsData();
    }
    renderStockTracker();
  }
});

tabBatches.addEventListener('click', () => {
  tabBatches.classList.add('active');
  tabProducts.classList.remove('active');
  contentBatches.classList.add('active');
  contentProducts.classList.remove('active');
});

// Date and expiry functions
function parseDate(dateStr) {
  if (!dateStr) return null;
  const parts = dateStr.split('/');
  if (parts.length === 3) {
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }
  const isoDate = new Date(dateStr);
  if (!isNaN(isoDate)) return isoDate;
  return null;
}

function calculateDaysBetween(date1, date2) {
  if (!date1 || !date2) return 0;
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  const diffTime = d2 - d1;
  return Math.max(0, Math.floor(diffTime / (1000 * 60 * 60 * 24)));
}

function formatDate(date) {
  if (!date) return 'Not Available';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2); // Get last 2 digits
  return `${day}/${month}/${year}`;
}

function formatTimeToExpiry(days) {
  if (days > 365) {
    const years = days / 365;
    return years.toFixed(1) + ' years';
  } else if (days > 30) {
    const months = days / 30;
    const monthsFormatted = months % 1 === 0 ? Math.floor(months) : months.toFixed(1);
    return monthsFormatted + ' month' + (monthsFormatted != 1 ? 's' : '');
  } else if (days > 13) {
    const weeks = days / 7;
    const weeksFormatted = weeks % 1 === 0 ? Math.floor(weeks) : weeks.toFixed(1);
    return weeksFormatted + ' week' + (weeksFormatted != 1 ? 's' : '');
  } else {
    return days + ' day' + (days !== 1 ? 's' : '');
  }
}

function getTempCol(temp) {
  if (temp === 21) return 4;
  if (temp === 5) return 5;
  if (temp === -18) return 6;
  return 4; // Default to ambient
}

// Get color for a specific bar index (0-19)
function getBarColor(barIndex) {
  const colorIndex = Math.floor(barIndex / 2);
  return gradientColors[Math.min(colorIndex, gradientColors.length - 1)];
}

// Get color based on percentage filled (for text color)
function getColorForPercent(percent) {
  if (percent >= 100) return '#dc2626';
  const barIndex = Math.floor(percent / 5);
  return getBarColor(Math.min(barIndex, 19));
}

function checkAndShowExpiryBar() {
  const expiryBarContainer = document.getElementById('expiry-bar-container');
  const storageTabsContainer = document.getElementById('storage-tabs-container');
  const purchaseDateValue = document.getElementById('purchase-date-input').value;
  const notPurchased = document.getElementById('not-purchased-checkbox').checked;
  
  // Check if first section has an active tab
  const firstSection = document.querySelector('.temp-section[data-section="1"]');
  const activeTab = firstSection ? firstSection.querySelector('.storage-method-tab.active') : null;
  
  // Hide storage tabs when purchase date is empty (and not purchased is unchecked)
  if (!purchaseDateValue && !notPurchased) {
    storageTabsContainer.style.display = 'none';
  } else {
    storageTabsContainer.style.display = 'block';
  }
  
  // Show expiry bar if purchase date exists AND storage tab selected
  if (purchaseDateValue && activeTab) {
    expiryBarContainer.style.display = 'flex';
    updateExpiryDisplay();
  } else {
    expiryBarContainer.style.display = 'none';
  }
  
  // Update save button visibility
  if (typeof updateSaveButtonVisibility === 'function') {
    updateSaveButtonVisibility();
  }
}

function updateExpiryDisplay() {
  if (!currentMatch) return;

  const notPurchased = document.getElementById('not-purchased-checkbox').checked;
  
  // Get all temperature sections data
  const tempSections = getTempSectionsData();
  
  if (tempSections.length === 0) return;

  const domDate = currentMatch[2] || '';
  const manufactureDate = parseDate(domDate);
  const productName = currentMatch[1];
  const productMatch = productsData.find(row => row[0] && row[0].toUpperCase() === productName.toUpperCase());
  const preSaleTemp = productMatch ? parseInt(productMatch[1]) : 21;
  const preCol = getTempCol(preSaleTemp);
  const ambientCol = 4;

  const shelfPreExpiry = parseDate(currentMatch[preCol]);
  const shelfAmbientExpiry = parseDate(currentMatch[ambientCol]);

  // Update DOM display - convert to dd/mm/yy format
  let domDisplayText = domDate || 'Not Available';
  if (domDate && domDate.includes('/')) {
    // Convert dd/mm/yyyy to dd/mm/yy
    const parts = domDate.split('/');
    if (parts.length === 3 && parts[2].length === 4) {
      domDisplayText = `${parts[0]}/${parts[1]}/${parts[2].slice(-2)}`;
    }
  }
  document.getElementById('dom-display').textContent = domDisplayText;

  if (!manufactureDate || !shelfPreExpiry || !shelfAmbientExpiry) {
    document.getElementById('expiry-display').textContent = 'Not Available';
    document.getElementById('expiry-time-text').textContent = '';
    const svg = document.getElementById('expiry-bar-svg');
    svg.innerHTML = '<rect x="0" y="30" width="100%" height="24" fill="#222" rx="4" stroke="#555" stroke-width="1"/>';
    return;
  }

  const shelfPreDays = calculateDaysBetween(manufactureDate, shelfPreExpiry);
  const shelfAmbientDays = calculateDaysBetween(manufactureDate, shelfAmbientExpiry);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let purchaseDateStr = document.getElementById('purchase-date-input').value;
  let purchaseDate = purchaseDateStr ? new Date(purchaseDateStr) : null;
  if (purchaseDate) purchaseDate.setHours(0, 0, 0, 0);

  let degradedPre = 0;
  let degradedShip = 0;
  let degradedSections = [];
  let tempChanges = []; // Store temp change info for visual markers

  let daysPre = 0;
  let daysShip = 0;

  if (notPurchased || !purchaseDate || purchaseDate > today) {
    // Only pre-dispatch, up to today
    daysPre = calculateDaysBetween(manufactureDate, today);
    degradedPre = shelfPreDays > 0 ? daysPre / shelfPreDays : 0;
  } else {
    // Pre-dispatch: manufacture to purchase
    daysPre = calculateDaysBetween(manufactureDate, purchaseDate);
    degradedPre = shelfPreDays > 0 ? daysPre / shelfPreDays : 0;

    // Determine shipping days
    let shippingDaysFull = 6; // Default international
    const orderSelect = document.getElementById('order-number-select');
    if (orderSelect.value !== '') {
      const selectedOption = orderSelect.options[orderSelect.selectedIndex];
      const country = selectedOption.getAttribute('data-country');
      if (country === 'GB' || country === 'UK') {
        shippingDaysFull = 2;
      }
    }

    const arrivalDate = new Date(purchaseDate);
    arrivalDate.setDate(arrivalDate.getDate() + shippingDaysFull);

    if (today < arrivalDate) {
      // During shipment
      daysShip = calculateDaysBetween(purchaseDate, today);
      degradedShip = shelfAmbientDays > 0 ? daysShip / shelfAmbientDays : 0;
    } else {
      // Received - now handle multiple temperature sections
      daysShip = shippingDaysFull;
      degradedShip = shelfAmbientDays > 0 ? daysShip / shelfAmbientDays : 0;
      
      // Process each temperature section
      let sectionStartDate = new Date(arrivalDate);
      let prevTemp = null;
      
      for (let i = 0; i < tempSections.length; i++) {
        const section = tempSections[i];
        const shelfDaysForTemp = calculateDaysBetween(manufactureDate, parseDate(currentMatch[section.colIndex]));
        
        let sectionEndDate;
        if (section.untilNow || !section.untilDate) {
          // This section goes until today
          sectionEndDate = new Date(today);
        } else {
          // This section goes until specified date
          const parts = section.untilDate.split('-');
          sectionEndDate = new Date(parts[0], parts[1] - 1, parts[2]);
          sectionEndDate.setHours(0, 0, 0, 0);
          
          // Don't allow future dates
          if (sectionEndDate > today) {
            sectionEndDate = new Date(today);
          }
        }
        
        // Calculate degradation for this section
        const sectionDays = calculateDaysBetween(sectionStartDate, sectionEndDate);
        const sectionDegraded = shelfDaysForTemp > 0 ? sectionDays / shelfDaysForTemp : 0;
        
        degradedSections.push({
          temp: section.temp,
          days: sectionDays,
          degraded: sectionDegraded,
          startDate: new Date(sectionStartDate),
          endDate: new Date(sectionEndDate)
        });
        
        // Track temperature changes for visual markers (skip first section)
        if (i > 0 && prevTemp !== null && prevTemp !== section.temp) {
          tempChanges.push({
            position: degradedPre + degradedShip + degradedSections.slice(0, i).reduce((sum, s) => sum + s.degraded, 0),
            label: getTempChangeLabel(prevTemp, section.temp),
            date: new Date(sectionStartDate)
          });
        }
        
        prevTemp = section.temp;
        sectionStartDate = new Date(sectionEndDate);
        
        // If this section ends at today, break
        if (section.untilNow || !section.untilDate || sectionEndDate.getTime() === today.getTime()) {
          break;
        }
      }
    }
  }

  // Calculate total degradation
  const totalSectionsDegraded = degradedSections.reduce((sum, s) => sum + s.degraded, 0);
  let totalDegraded = degradedPre + degradedShip + totalSectionsDegraded;
  let expiredPercent = Math.min(100, totalDegraded * 100);

  // Calculate remaining and expiry date (using last section's shelf life)
  const lastSection = degradedSections.length > 0 ? degradedSections[degradedSections.length - 1] : null;
  const finalColIndex = lastSection ? tempSections[degradedSections.length - 1].colIndex : (tempSections[0] ? tempSections[0].colIndex : 4);
  const shelfCustomerExpiry = parseDate(currentMatch[finalColIndex]);
  const shelfCustomerDays = calculateDaysBetween(manufactureDate, shelfCustomerExpiry);
  
  let remainingDegraded = Math.max(0, 1 - totalDegraded);
  let remainingDays = Math.floor(remainingDegraded * shelfCustomerDays);
  let expiryDate = new Date(today);
  expiryDate.setDate(expiryDate.getDate() + remainingDays);

  const expiryDisplay = document.getElementById('expiry-display');
  expiryDisplay.textContent = formatDate(expiryDate);

  const expiryTimeText = document.getElementById('expiry-time-text');
  let textColor = getColorForPercent(expiredPercent);
  
  if (totalDegraded >= 1) {
    expiryTimeText.textContent = 'EXPIRED - please discard';
    textColor = '#dc2626';
    remainingDays = 0;
  } else {
    const timeText = formatTimeToExpiry(remainingDays);
    expiryTimeText.textContent = timeText + ' to expiry';
  }
  expiryTimeText.style.color = textColor;

  // Build SVG with 20 mini-bars
  const svg = document.getElementById('expiry-bar-svg');
  svg.innerHTML = '';
  
  const barHeight = 24;
  const barY = 30;
  const totalBars = 20;
  const barGap = 2;
  
  // Calculate bar width as percentage
  const barWidthPercent = (100 - (barGap * (totalBars - 1) / 100 * 100)) / totalBars;
  
  // Background container
  const bgRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  bgRect.setAttribute('x', '0');
  bgRect.setAttribute('y', barY.toString());
  bgRect.setAttribute('width', '100%');
  bgRect.setAttribute('height', barHeight.toString());
  bgRect.setAttribute('fill', '#222');
  bgRect.setAttribute('rx', '4');
  bgRect.setAttribute('stroke', '#555');
  bgRect.setAttribute('stroke-width', '1');
  svg.appendChild(bgRect);

  // Draw 20 mini-bars
  for (let i = 0; i < totalBars; i++) {
    const barStartPercent = i * (100 / totalBars);
    const barEndPercent = (i + 1) * (100 / totalBars);
    const barColor = getBarColor(i);
    
    // Calculate how much of this bar should be filled
    let fillWidth = 0;
    if (expiredPercent >= barEndPercent) {
      // Bar is fully filled
      fillWidth = 100 / totalBars;
    } else if (expiredPercent > barStartPercent) {
      // Bar is partially filled
      fillWidth = expiredPercent - barStartPercent;
    }
    
    if (fillWidth > 0) {
      const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      const xPos = barStartPercent;
      rect.setAttribute('x', xPos + '%');
      rect.setAttribute('y', barY.toString());
      rect.setAttribute('width', fillWidth + '%');
      rect.setAttribute('height', barHeight.toString());
      rect.setAttribute('fill', barColor);
      
      // Round corners on first and last bars
      if (i === 0) {
        rect.setAttribute('rx', '4');
        rect.setAttribute('ry', '4');
        // Clip right corners
        rect.setAttribute('clip-path', 'inset(0 0 0 0 round 4px 0 0 4px)');
      }
      
      svg.appendChild(rect);
    }
    
    // Add separator line between bars (except for last bar)
    if (i < totalBars - 1) {
      const separatorX = barEndPercent;
      const separator = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      separator.setAttribute('x1', separatorX + '%');
      separator.setAttribute('y1', barY.toString());
      separator.setAttribute('x2', separatorX + '%');
      separator.setAttribute('y2', (barY + barHeight).toString());
      separator.setAttribute('stroke', '#333');
      separator.setAttribute('stroke-width', '1');
      svg.appendChild(separator);
    }
  }

  let prePos = Math.min(degradedPre * 100, 100);
  let shipPos = Math.min((degradedPre + degradedShip) * 100, 100);
  let totalPos = expiredPercent;

  // Add dividers (black lines) for phase boundaries
  if (degradedShip > 0 || degradedSections.length > 0) {
    const preDivider = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    preDivider.setAttribute('x1', prePos + '%');
    preDivider.setAttribute('y1', barY.toString());
    preDivider.setAttribute('x2', prePos + '%');
    preDivider.setAttribute('y2', (barY + barHeight).toString());
    preDivider.setAttribute('stroke', 'black');
    preDivider.setAttribute('stroke-width', '2');
    svg.appendChild(preDivider);
  }
  
  if (degradedSections.length > 0) {
    const shipDivider = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    shipDivider.setAttribute('x1', shipPos + '%');
    shipDivider.setAttribute('y1', barY.toString());
    shipDivider.setAttribute('x2', shipPos + '%');
    shipDivider.setAttribute('y2', (barY + barHeight).toString());
    shipDivider.setAttribute('stroke', 'black');
    shipDivider.setAttribute('stroke-width', '2');
    svg.appendChild(shipDivider);
  }
  
  // Add dividers for temperature changes
  tempChanges.forEach(change => {
    const changePos = Math.min(change.position * 100, 100);
    const changeDivider = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    changeDivider.setAttribute('x1', changePos + '%');
    changeDivider.setAttribute('y1', barY.toString());
    changeDivider.setAttribute('x2', changePos + '%');
    changeDivider.setAttribute('y2', (barY + barHeight).toString());
    changeDivider.setAttribute('stroke', 'black');
    changeDivider.setAttribute('stroke-width', '2');
    svg.appendChild(changeDivider);
  });

  // Add labels with arrows
  // Dispatch label - always shows above bar with downward arrow
  if (degradedPre > 0) {
    const preArrow = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    preArrow.setAttribute('x', prePos + '%');
    preArrow.setAttribute('y', '25');
    preArrow.setAttribute('fill', 'white');
    preArrow.setAttribute('font-size', '14');
    preArrow.setAttribute('text-anchor', 'middle');
    preArrow.textContent = '↓';
    svg.appendChild(preArrow);

    const preLabel = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    // Shift label to stay inside field box
    let preLabelAnchor = 'middle';
    let preLabelX = prePos;
    if (prePos < 8) {
      preLabelAnchor = 'start';
      preLabelX = 1;
    } else if (prePos > 92) {
      preLabelAnchor = 'end';
      preLabelX = 99;
    }
    preLabel.setAttribute('x', preLabelX + '%');
    preLabel.setAttribute('y', '12');
    preLabel.setAttribute('fill', 'white');
    preLabel.setAttribute('font-size', '10');
    preLabel.setAttribute('text-anchor', preLabelAnchor);
    preLabel.textContent = 'Dispatch';
    svg.appendChild(preLabel);
  }
  
  // Arrival label - shows below bar
  if (degradedShip > 0) {
    const shipArrow = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    shipArrow.setAttribute('x', shipPos + '%');
    shipArrow.setAttribute('y', '66');
    shipArrow.setAttribute('fill', 'white');
    shipArrow.setAttribute('font-size', '14');
    shipArrow.setAttribute('text-anchor', 'middle');
    shipArrow.textContent = '↑';
    svg.appendChild(shipArrow);

    const shipLabel = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    // Shift label to stay inside field box
    let shipLabelAnchor = 'middle';
    let shipLabelX = shipPos;
    if (shipPos < 8) {
      shipLabelAnchor = 'start';
      shipLabelX = 1;
    } else if (shipPos > 92) {
      shipLabelAnchor = 'end';
      shipLabelX = 99;
    }
    shipLabel.setAttribute('x', shipLabelX + '%');
    shipLabel.setAttribute('y', '78');
    shipLabel.setAttribute('fill', 'white');
    shipLabel.setAttribute('font-size', '10');
    shipLabel.setAttribute('text-anchor', shipLabelAnchor);
    shipLabel.textContent = 'Arrival';
    svg.appendChild(shipLabel);
  }
  
  // Add temperature change labels (alternate above and below bar)
  tempChanges.forEach((change, index) => {
    const changePos = Math.min(change.position * 100, 100);
    const isAbove = index % 2 === 0; // Alternate above and below
    
    // Arrow
    const changeArrow = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    changeArrow.setAttribute('x', changePos + '%');
    changeArrow.setAttribute('y', isAbove ? '25' : '66');
    changeArrow.setAttribute('fill', 'white');
    changeArrow.setAttribute('font-size', '14');
    changeArrow.setAttribute('text-anchor', 'middle');
    changeArrow.textContent = isAbove ? '↓' : '↑';
    svg.appendChild(changeArrow);
    
    // Label
    const changeLabel = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    let changeLabelAnchor = 'middle';
    let changeLabelX = changePos;
    if (changePos < 8) {
      changeLabelAnchor = 'start';
      changeLabelX = 1;
    } else if (changePos > 92) {
      changeLabelAnchor = 'end';
      changeLabelX = 99;
    }
    changeLabel.setAttribute('x', changeLabelX + '%');
    changeLabel.setAttribute('y', isAbove ? '12' : '78');
    changeLabel.setAttribute('fill', 'white');
    changeLabel.setAttribute('font-size', '10');
    changeLabel.setAttribute('text-anchor', changeLabelAnchor);
    changeLabel.textContent = change.label;
    svg.appendChild(changeLabel);
  });
  
  // Add percentage label (if not 100% expired)
  const percentTitle = document.getElementById('expiry-percent-title');
  if (totalDegraded < 1 && expiredPercent > 0) {
    percentTitle.style.display = 'block';
    
    // Create percentage label
    const percentLabel = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    const percentText = Math.round(expiredPercent) + '%';
    
    // Position: right of filled bar if space, left if not
    let percentX;
    let percentAnchor;
    let percentColor = 'white';
    
    if (expiredPercent > 90) {
      // Not enough space on right - put on left of bar end
      percentX = expiredPercent - 2;
      percentAnchor = 'end';
      percentColor = 'white';
    } else {
      // Default: right of filled bar
      percentX = expiredPercent + 2;
      percentAnchor = 'start';
    }
    
    percentLabel.setAttribute('x', percentX + '%');
    percentLabel.setAttribute('y', (barY + barHeight / 2 + 4).toString());
    percentLabel.setAttribute('fill', percentColor);
    percentLabel.setAttribute('font-size', '11');
    percentLabel.setAttribute('font-weight', 'bold');
    percentLabel.setAttribute('text-anchor', percentAnchor);
    percentLabel.textContent = percentText;
    svg.appendChild(percentLabel);
  } else {
    percentTitle.style.display = 'none';
  }
}

// Storage Method Tabs
document.querySelectorAll('.storage-method-tab').forEach(tab => {
  tab.addEventListener('click', function() {
    // Only handle tabs in the same section
    const section = this.closest('.temp-section');
    if (section) {
      section.querySelectorAll('.storage-method-tab').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      checkAndShowExpiryBar();
      
      // Revert to unsaved state when storage temp changes
      if (section.getAttribute('data-section') === '1') {
        showUnsavedState();
      }
    }
  });
});

// Handle "Until now" checkbox changes
function setupTempSectionListeners() {
  document.querySelectorAll('.until-now-checkbox').forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      const sectionNum = this.getAttribute('data-section');
      const dateContainer = document.querySelector(`.until-date-container[data-section="${sectionNum}"]`);
      
      if (this.checked) {
        // Hide date field
        dateContainer.style.display = 'none';
        // Remove any sections after this one
        removeSubsequentSections(parseInt(sectionNum));
      } else {
        // Show date field
        dateContainer.style.display = 'flex';
      }
      
      updateExpiryDisplay();
      updateSaveButtonVisibility();
    });
  });
  
  // Handle date input changes
  document.querySelectorAll('.until-date-input').forEach(input => {
    input.addEventListener('change', function() {
      const sectionNum = parseInt(this.getAttribute('data-section'));
      
      if (this.value) {
        // Check if date is fully entered and valid (not auto-completed partial)
        const enteredDate = new Date(this.value);
        const currentYear = new Date().getFullYear();
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // Only validate if:
        // 1. Date is valid
        // 2. Year is reasonable (between 2020 and current year + 10)
        // 3. Date string is properly formatted (YYYY-MM-DD)
        if (isNaN(enteredDate.getTime()) || 
            enteredDate.getFullYear() < 2020 || 
            enteredDate.getFullYear() > currentYear + 10 ||
            this.value.length !== 10) {
          // Date is incomplete or invalid - wait for user to finish
          return;
        }
        
        // Check if date is in the future
        if (enteredDate > today) {
          alert('Date cannot be in the future');
          this.value = '';
          updateSaveButtonVisibility();
          return;
        }
        
        // Validate date - must be after previous section or purchase date
        let minDate;
        if (sectionNum === 1) {
          // First section: must be after purchase date
          const purchaseDate = document.getElementById('purchase-date-input').value;
          if (purchaseDate) {
            minDate = new Date(purchaseDate);
            // Add shipping days
            const orderSelect = document.getElementById('order-number-select');
            if (orderSelect && orderSelect.value !== '') {
              const selectedOption = orderSelect.options[orderSelect.selectedIndex];
              const country = selectedOption.getAttribute('data-country');
              const shippingDays = (country === 'GB' || country === 'UK') ? 2 : 6;
              minDate.setDate(minDate.getDate() + shippingDays);
            }
          }
        } else {
          // Subsequent sections: must be after previous section's date
          const prevSection = document.querySelector(`.temp-section[data-section="${sectionNum - 1}"]`);
          if (prevSection) {
            const prevDateInput = prevSection.querySelector('.until-date-input');
            if (prevDateInput && prevDateInput.value) {
              minDate = new Date(prevDateInput.value);
            }
          }
        }
        
        // Validate the entered date
        if (minDate) {
          if (enteredDate <= minDate) {
            alert('Date must be after ' + (sectionNum === 1 ? 'arrival date' : 'previous temperature change date'));
            this.value = '';
            updateSaveButtonVisibility();
            return;
          }
        }
        
        // Check if next section exists, if not, add it
        const nextSection = document.querySelector(`.temp-section[data-section="${sectionNum + 1}"]`);
        if (!nextSection) {
          addTempSection(sectionNum + 1);
        }
      }
      
      updateExpiryDisplay();
      updateSaveButtonVisibility();
    });
  });
}

// Add a new temperature section
function addTempSection(sectionNum) {
  const container = document.getElementById('temp-sections-container');
  
  // Get today's date for max attribute
  const today = new Date().toISOString().split('T')[0];
  
  const newSection = document.createElement('div');
  newSection.className = 'temp-section';
  newSection.setAttribute('data-section', sectionNum);
  newSection.style.marginTop = '20px';
  newSection.style.paddingTop = '15px';
  newSection.style.borderTop = '1px solid #444';
  
  newSection.innerHTML = `
    <div class="small-text" style="margin-bottom: 8px;">Temperature ${sectionNum}:</div>
    <div class="storage-method-tabs">
      <div class="storage-method-tab ambient" data-col="4" data-temp="21">Ambient (21°C)</div>
      <div class="storage-method-tab refrigerated" data-col="5" data-temp="5">Refrigerated (5°C)</div>
      <div class="storage-method-tab frozen" data-col="6" data-temp="-18">Frozen (-18°C)</div>
    </div>
    
    <div style="margin-top: 10px; display: flex; gap: 15px; align-items: center;">
      <label style="display: flex; align-items: center; cursor: pointer;">
        <input type="checkbox" class="until-now-checkbox" data-section="${sectionNum}" checked style="margin-right: 6px;" />
        <span style="font-size: 13px; color: white;">Until now</span>
      </label>
      
      <div class="until-date-container" data-section="${sectionNum}" style="display: none; flex: 1;">
        <label style="font-size: 12px; color: #999; margin-right: 8px;">Until:</label>
        <input type="date" class="until-date-input" data-section="${sectionNum}" max="${today}" style="background: #111; border: 1px solid #555; border-radius: 8px; color: white; padding: 6px 10px; font-size: 13px; flex: 1;" />
      </div>
    </div>
  `;
  
  container.appendChild(newSection);
  
  // Attach event listeners to the new section's tabs
  newSection.querySelectorAll('.storage-method-tab').forEach(tab => {
    tab.addEventListener('click', function() {
      const section = this.closest('.temp-section');
      if (section) {
        section.querySelectorAll('.storage-method-tab').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        updateExpiryDisplay();
        updateSaveButtonVisibility();
        
        // Revert to unsaved state when storage temp changes in section 1
        if (section.getAttribute('data-section') === '1') {
          showUnsavedState();
        }
      }
    });
  });
  
  // Add listener for until-now checkbox
  const untilNowCheckbox = newSection.querySelector('.until-now-checkbox');
  if (untilNowCheckbox) {
    untilNowCheckbox.addEventListener('change', () => {
      updateSaveButtonVisibility();
    });
  }
  
  // Add listener for until-date input
  const untilDateInput = newSection.querySelector('.until-date-input');
  if (untilDateInput) {
    untilDateInput.addEventListener('change', () => {
      updateSaveButtonVisibility();
    });
  }
  
  setupTempSectionListeners();
}

// Remove sections after a given section number
function removeSubsequentSections(sectionNum) {
  const allSections = document.querySelectorAll('.temp-section');
  allSections.forEach(section => {
    const num = parseInt(section.getAttribute('data-section'));
    if (num > sectionNum) {
      section.remove();
    }
  });
}

// Get all temperature sections data
function getTempSectionsData() {
  const sections = [];
  const allSections = document.querySelectorAll('.temp-section');
  
  allSections.forEach((section, index) => {
    const sectionNum = parseInt(section.getAttribute('data-section'));
    const activeTab = section.querySelector('.storage-method-tab.active');
    const untilNowCheckbox = section.querySelector('.until-now-checkbox');
    const untilDateInput = section.querySelector('.until-date-input');
    
    if (activeTab) {
      const temp = parseInt(activeTab.getAttribute('data-temp'));
      const colIndex = parseInt(activeTab.getAttribute('data-col'));
      const untilNow = untilNowCheckbox ? untilNowCheckbox.checked : true;
      const untilDate = (untilDateInput && untilDateInput.value) ? untilDateInput.value : null;
      
      sections.push({
        section: sectionNum,
        temp: temp,
        colIndex: colIndex,
        untilNow: untilNow,
        untilDate: untilDate
      });
    }
  });
  
  return sections;
}

// Get temperature change label
function getTempChangeLabel(prevTemp, newTemp) {
  if (prevTemp === -18 && newTemp === 21) return 'Thawed';
  if (prevTemp === -18 && newTemp === 5) return 'Thawed (5°C)';
  if (prevTemp === 5 && newTemp === 21) return 'Unrefrigerated';
  if (prevTemp === 5 && newTemp === -18) return 'Frozen';
  if (prevTemp === 21 && newTemp === 5) return 'Refrigerated';
  if (prevTemp === 21 && newTemp === -18) return 'Frozen';
  return 'Changed';
}

// Initialize temp section listeners on page load
setupTempSectionListeners();

// Order/Purchase Logic
const notPurchasedCheckbox = document.getElementById('not-purchased-checkbox');
const orderNumberSelect = document.getElementById('order-number-select');
const purchaseDateInput = document.getElementById('purchase-date-input');
let currentSkuBase = '';

// Check if order SKU contains the product's base identifier
function skuMatches(orderSku, productBase) {
  if (!orderSku || !productBase) return false;
  
  const orderSkuUpper = orderSku.toUpperCase();
  const productBaseUpper = productBase.toUpperCase();
  
  // Direct contains check
  if (orderSkuUpper.includes(productBaseUpper)) return true;
  
  // Special case: GL and LG are synonyms for glutathione only
  if (productBaseUpper === 'GL' && orderSkuUpper.includes('LG')) return true;
  if (productBaseUpper === 'LG' && orderSkuUpper.includes('GL')) return true;
  
  // Special case: BW and MW are synonyms for bacteriostatic water
  if (productBaseUpper === 'BW' && orderSkuUpper.includes('MW')) return true;
  if (productBaseUpper === 'MW' && orderSkuUpper.includes('BW')) return true;
  
  return false;
}

// Filter dropdown to only show orders that contain the product AND are within batch's H:I range
function filterOrderDropdown() {
  const options = orderNumberSelect.querySelectorAll('option');
  let visibleOptions = [];
  
  // Get the H:I range from current batch
  const firstOrderRaw = currentMatch ? currentMatch[7] : null;
  const lastOrderRaw = currentMatch ? currentMatch[8] : null;
  const firstOrder = parseInt(firstOrderRaw) || 0;
  const lastOrder = parseInt(lastOrderRaw) || 999999;
  
  // Get product name from current match
  const productName = currentProductName ? currentProductName.trim().toUpperCase() : '';
  
  console.log('Filtering orders for product:', productName);
  console.log('Batch H:I raw values:', firstOrderRaw, lastOrderRaw);
  console.log('Batch H:I parsed range:', firstOrder, '-', lastOrder);
  
  options.forEach((option, index) => {
    if (index === 0) return; // Skip "Select an order..." option
    
    // Extract order number from option text (format: "#SS12345 - DD/MM/YYYY")
    const orderMatch = option.textContent.match(/#SS(\d+)/);
    const orderNum = orderMatch ? parseInt(orderMatch[1]) : 0;
    
    // Get products from this order
    const productsString = option.getAttribute('data-products') || '';
    const orderProducts = productsString.split('|||').map(s => s.trim().toUpperCase());
    
    // Check if order contains the product (flexible match - product name is contained in line item title)
    const hasProduct = orderProducts.some(p => p.includes(productName) || productName.includes(p));
    
    // Check if order number falls within batch's H:I range
    const inRange = orderNum >= firstOrder && orderNum <= lastOrder;
    
    console.log('Order', orderNum, '- Has product:', hasProduct, 'In range:', inRange);
    
    // Show only if both conditions are met
    if (hasProduct && inRange) {
      option.hidden = false;
      option.disabled = false;
      visibleOptions.push(option);
    } else {
      option.hidden = true;
      option.disabled = true;
    }
  });
  
  // If only 1 order matches, auto-select it
  if (visibleOptions.length === 1) {
    orderNumberSelect.value = visibleOptions[0].value;
    purchaseDateInput.value = visibleOptions[0].value;
    document.getElementById('storage-tabs-container').style.display = 'block';
    updateShippingTypeBullet();
  } else {
    // Reset to default option
    orderNumberSelect.value = '';
  }
}

// Update storage condition bullet - always shown when batch details are visible
function updateStorageConditionBullet() {
  const orderInfoBullets = document.getElementById('order-info-bullets');
  const storageConditionBullet = document.getElementById('storage-condition-bullet');
  
  // Storage condition based on products!B:B (index 1)
  try {
    if (currentProductName) {
      const productMatch = productsData.find(row => row[0] && row[0].toUpperCase() === currentProductName.toUpperCase());
      if (productMatch && productMatch[1]) {
        const tempValue = parseInt(productMatch[1]);
        let storageText = '';
        
        if (tempValue === 5) {
          storageText = 'Refrigerated until dispatch';
        } else if (tempValue === 21) {
          storageText = 'Stored at ambient until dispatch';
        } else if (tempValue === -18) {
          storageText = 'Frozen until dispatch';
        }
        
        if (storageText) {
          storageConditionBullet.innerHTML = '<span class="checkmark">✓</span>' + storageText;
          storageConditionBullet.style.display = 'block';
          orderInfoBullets.style.display = 'block';
          return;
        }
      }
    }
    storageConditionBullet.style.display = 'none';
  } catch (e) {
    storageConditionBullet.style.display = 'none';
  }
}

// Update shipping type bullet - only shown when order is selected
function updateShippingTypeBullet() {
  const orderInfoBullets = document.getElementById('order-info-bullets');
  const shippingTypeBullet = document.getElementById('shipping-type-bullet');
  
  const selectedOption = orderNumberSelect.options[orderNumberSelect.selectedIndex];
  
  // Only show if an order is selected (not default option)
  if (!selectedOption || !selectedOption.value) {
    shippingTypeBullet.style.display = 'none';
    return;
  }
  
  // Shipping type based on country code
  try {
    const countryCode = selectedOption.getAttribute('data-country');
    if (countryCode) {
      const isUK = countryCode === 'GB' || countryCode === 'UK';
      const shippingText = isUK ? 'UK shipping' : 'International shipping';
      shippingTypeBullet.innerHTML = '<span class="checkmark">✓</span>' + shippingText;
      shippingTypeBullet.style.display = 'block';
      orderInfoBullets.style.display = 'block';
    } else {
      shippingTypeBullet.style.display = 'none';
    }
  } catch (e) {
    shippingTypeBullet.style.display = 'none';
  }
}

function updateInputStates() {
  const hasOrders = orderNumberSelect.options.length > 1;
  const storageTabsContainer = document.getElementById('storage-tabs-container');
  
  if (notPurchasedCheckbox.checked) {
    orderNumberSelect.disabled = true;
    orderNumberSelect.style.opacity = '0.5';
    orderNumberSelect.style.cursor = 'not-allowed';
    orderNumberSelect.value = '';
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    purchaseDateInput.value = `${year}-${month}-${day}`;
    document.getElementById('shipping-type-bullet').style.display = 'none';
    
    // Show storage temperature tabs when not purchased
    storageTabsContainer.style.display = 'block';
    
    // Hide "until now" checkbox and date field in first section
    const firstSection = document.querySelector('.temp-section[data-section="1"]');
    if (firstSection) {
      const untilNowContainer = firstSection.querySelector('div[style*="margin-top: 10px"]');
      if (untilNowContainer) {
        untilNowContainer.style.display = 'none';
      }
    }
    
    // Remove all sections after section 1
    removeSubsequentSections(1);
  } else {
    if (hasOrders) {
      orderNumberSelect.disabled = false;
      orderNumberSelect.style.opacity = '1';
      orderNumberSelect.style.cursor = 'pointer';
    }
    // Clear purchase date when unchecking "not yet purchased"
    purchaseDateInput.value = '';
    document.getElementById('shipping-type-bullet').style.display = 'none';
    
    // Show storage temperature tabs
    storageTabsContainer.style.display = 'block';
    
    // Show "until now" checkbox and date field in first section
    const firstSection = document.querySelector('.temp-section[data-section="1"]');
    if (firstSection) {
      const untilNowContainer = firstSection.querySelector('div[style*="margin-top: 10px"]');
      if (untilNowContainer) {
        untilNowContainer.style.display = 'flex';
      }
    }
  }
  checkAndShowExpiryBar();
  // Explicitly update save button visibility after checkbox state changes
  updateSaveButtonVisibility();
}

notPurchasedCheckbox.addEventListener('change', updateInputStates);

orderNumberSelect.addEventListener('change', function() {
  const selectedOption = this.options[this.selectedIndex];
  const storageTabsContainer = document.getElementById('storage-tabs-container');
  
  if (!selectedOption.value) {
    purchaseDateInput.value = '';
    document.getElementById('shipping-type-bullet').style.display = 'none';
    storageTabsContainer.style.display = 'none';
    checkAndShowExpiryBar();
    return;
  }
  
  const orderDate = selectedOption.value;
  purchaseDateInput.value = orderDate;
  storageTabsContainer.style.display = 'block';
  updateShippingTypeBullet();
  checkAndShowExpiryBar();
});

purchaseDateInput.addEventListener('change', function() {
  const storageTabsContainer = document.getElementById('storage-tabs-container');
  if (this.value) {
    storageTabsContainer.style.display = 'block';
  } else {
    storageTabsContainer.style.display = 'none';
  }
  checkAndShowExpiryBar();
});

// Batch Search
function handleBatchSearch() {
  console.log('handleBatchSearch() called');
  
  const batchInput = document.getElementById('batch-code-input');
  const batchDetails = document.getElementById('batch-details');
  const batchError = document.getElementById('batch-error');
  const productNameDisplay = document.getElementById('product-name-display');
  const domDisplay = document.getElementById('dom-display');
  const dataWarning = document.getElementById('data-warning');
  
  if (!batchInput) {
    console.error('✗ Batch input element not found in handleBatchSearch');
    return;
  }
  
  const code = batchInput.value.trim().toUpperCase();
  console.log('Searching for batch code:', code);
  
  if (!code) {
    console.warn('✗ No batch code to search');
    return;
  }

  batchDetails.style.display = 'none';
  batchError.style.display = 'none';
  dataWarning.style.display = 'none';

  if (!isDataLoaded) {
    batchError.innerHTML = 'Data is still loading. Please wait a moment and try again.';
    batchError.style.display = 'block';
    document.getElementById('recent-batches').style.display = 'block';
    return;
  }

  if (batchData.length === 0) {
    dataWarning.style.display = 'block';
    document.getElementById('recent-batches').style.display = 'block';
    return;
  }

  const match = batchData.find(row => row[0] && row[0].toUpperCase() === code);

  if (match) {
    const productName = match[1] || 'Unknown Product';
    productNameDisplay.value = productName;
    domDisplay.textContent = match[2] || 'Not Available';
    
    currentMatch = match;
    currentProductName = productName;
    
    // Get SKU base from products!L:L (index 11)
    const productMatch = productsData.find(row => row[0] && row[0].toUpperCase() === productName.toUpperCase());
    if (productMatch && productMatch[11]) {
      currentSkuBase = productMatch[11].trim();
    } else {
      currentSkuBase = '';
    }
    
    // Filter order dropdown to only show relevant orders
    filterOrderDropdown();
    
    // Prefill order number if coming from MY BATCHES tab
    if (window.prefillOrderNumber) {
      const options = orderNumberSelect.querySelectorAll('option');
      for (let option of options) {
        // Check if option text contains the order number
        if (option.textContent.includes('#SS' + window.prefillOrderNumber)) {
          orderNumberSelect.value = option.value;
          purchaseDateInput.value = option.value;
          updateShippingTypeBullet();
          break;
        }
      }
      window.prefillOrderNumber = null;
    }
    
    // Reset order-related fields (only if not prefilled)
    if (!orderNumberSelect.value) {
      notPurchasedCheckbox.checked = false;
      purchaseDateInput.value = '';
    }
    
    // Default temperature tabs to pre-dispatch storage temp from products!B:B
    document.querySelectorAll('.storage-method-tab').forEach(t => t.classList.remove('active'));
    if (productMatch && productMatch[1]) {
      const preSaleTemp = parseInt(productMatch[1]);
      let tabSelector = '';
      if (preSaleTemp === 21) {
        tabSelector = '.storage-method-tab.ambient';
      } else if (preSaleTemp === 5) {
        tabSelector = '.storage-method-tab.refrigerated';
      } else if (preSaleTemp === -18) {
        tabSelector = '.storage-method-tab.frozen';
      }
      if (tabSelector) {
        const defaultTab = document.querySelector(tabSelector);
        if (defaultTab) {
          defaultTab.classList.add('active');
        }
      }
    }
    
    // Hide storage tabs container initially (shown when date entered)
    const storageTabsContainer = document.getElementById('storage-tabs-container');
    if (!purchaseDateInput.value) {
      storageTabsContainer.style.display = 'none';
    } else {
      storageTabsContainer.style.display = 'block';
    }
    
    // Check and show expiry bar if conditions are met (date + storage tab)
    checkAndShowExpiryBar();
    
    // Hide shipping bullet initially, but show storage condition
    document.getElementById('shipping-type-bullet').style.display = 'none';
    updateStorageConditionBullet();

    if (productMatch) {
      const storageInstructions = productMatch[5] || 'Store in a cool, dry place. Protect from light and heat.';
      const productSpecs = productMatch[6] || 'No specifications available.';
      const imageUrl = productMatch[9] || '';
      const siteLink = productMatch[10] || '';

      const storageP = document.querySelector('.storage-box .field:nth-child(2) p');
      if (storageP) {
        storageP.innerHTML = storageInstructions.replace(/\n/g, '<br>');
      }

      const productImage = document.getElementById('product-image');
      const productImageMobile = document.getElementById('product-image-mobile');
      const productLink = document.getElementById('product-link');
      const productLinkMobile = document.getElementById('product-link-mobile');
      const productTextLink = document.getElementById('product-text-link');
      const productTextLinkMobile = document.getElementById('product-text-link-mobile');
      if (imageUrl) {
        productImage.src = imageUrl;
        productImage.style.display = 'block';
        productImageMobile.src = imageUrl;
        productImageMobile.style.display = 'block';
      } else {
        productImage.style.display = 'none';
        productImageMobile.style.display = 'none';
      }
      if (siteLink) {
        productLink.href = siteLink;
        productLinkMobile.href = siteLink;
        productTextLink.href = siteLink;
        productTextLinkMobile.href = siteLink;
      } else {
        productLink.href = '';
        productLinkMobile.href = '';
        productTextLink.href = '';
        productTextLinkMobile.href = '';
      }
    }

    const coaLink = match[3] ? match[3].trim() : '';
    const hplcBadgeDesktop = document.getElementById('hplc-badge-desktop');
    const hplcBadgeMobile = document.getElementById('hplc-badge-mobile');
    if (coaLink) {
      hplcBadgeDesktop.style.display = 'inline-flex';
      hplcBadgeMobile.style.display = 'flex';
      const viewCoaDesktop = hplcBadgeDesktop.querySelector('.small-text');
      const viewCoaMobile = hplcBadgeMobile.querySelector('.small-text');
      const coaHTML = `<a href="${coaLink}" target="_blank" style="color: #e3fc02; text-decoration: none;">View CoA ↗</a>`;
      viewCoaDesktop.innerHTML = coaHTML;
      viewCoaMobile.innerHTML = coaHTML;
    } else {
      hplcBadgeDesktop.style.display = 'none';
      hplcBadgeMobile.style.display = 'none';
    }

    batchDetails.style.display = 'block';
    document.getElementById('recent-batches').style.display = 'none';
    batchInput.value = '';
    document.querySelector('.tabs').style.display = 'none';
    document.getElementById('search-bar').style.display = 'none';
    document.getElementById('return-link').style.display = 'block';
    
    // Hide instructional text, order dropdown, and heading when showing results
    const batchInstructions = document.getElementById('batch-instructions');
    const orderDropdownContainer = document.getElementById('order-dropdown-container');
    const myBatchesTableContainer = document.getElementById('my-batches-table-container');
    const yourOrdersHeading = document.getElementById('your-orders-heading');
    if (batchInstructions) batchInstructions.style.display = 'none';
    if (orderDropdownContainer) orderDropdownContainer.style.display = 'none';
    if (myBatchesTableContainer) myBatchesTableContainer.style.display = 'none';
    if (yourOrdersHeading) yourOrdersHeading.style.display = 'none';
    
    // Reset saved state and attach change listeners
    showUnsavedState();
    attachInputChangeListeners();
    // Ensure save button visibility is correct based on all conditions
    updateSaveButtonVisibility();
  } else {
    batchError.innerHTML = `Batch code not found on SURGE database. Your product may be counterfeit or faulty. <a href="https://surgesolutions.shop/pages/contact" target="_blank">Contact support</a> for assistance.`;
    batchError.style.display = 'block';
    document.getElementById('recent-batches').style.display = 'block';
  }
}

// My Batches functionality
const myBatchesOrderSelect = document.getElementById('order-number-select-batches');
if (myBatchesOrderSelect) {
  myBatchesOrderSelect.addEventListener('change', function() {
    const tableContainer = document.getElementById('my-batches-table-container');
    const tbody = document.querySelector('#my-batches-table tbody');
    
    if (!this.value) {
      tableContainer.style.display = 'none';
      return;
    }
    
    // Check if data is loaded
    if (!isDataLoaded || batchData.length === 0) {
      tbody.innerHTML = '';
      const tr = document.createElement('tr');
      const td = document.createElement('td');
      td.colSpan = 2;
      td.textContent = 'Loading batch data...';
      td.style.cssText = 'border: 1px solid #555; padding: 8px; text-align: center; color: #e3fc02;';
      tr.appendChild(td);
      tbody.appendChild(tr);
      tableContainer.style.display = 'block';
      
      // Retry after a short delay
      setTimeout(() => {
        if (myBatchesOrderSelect.value) {
          myBatchesOrderSelect.dispatchEvent(new Event('change'));
        }
      }, 500);
      return;
    }
    
    const selectedOption = this.options[this.selectedIndex];
    const orderNumber = parseInt(this.value);
    const itemsString = selectedOption.getAttribute('data-items') || '';
    const items = itemsString.split('|||').map(s => s.trim()).filter(s => s);
    
    // Debug logging
    console.log('Order number:', orderNumber);
    console.log('Items from order:', items);
    console.log('Batch data loaded:', batchData.length, 'rows');
    
    // Remove duplicates while preserving order
    const uniqueItems = [...new Set(items)];
    
    // Clear table
    tbody.innerHTML = '';
    
    // Find batch codes for each item
    uniqueItems.forEach(productName => {
      const tr = document.createElement('tr');
      
      // Product name cell
      const tdProduct = document.createElement('td');
      tdProduct.style.cssText = 'border: 1px solid #555; padding: 8px; text-align: left;';
      tdProduct.textContent = productName;
      tr.appendChild(tdProduct);
      
      // Batch code cell
      const tdBatch = document.createElement('td');
      tdBatch.style.cssText = 'border: 1px solid #555; padding: 8px; text-align: left;';
      
      // Find matching batches where order number falls between H:H and I:I
      const matchingBatches = [];
      const productNameClean = productName.trim().toUpperCase();
      
      for (let row of batchData) {
        const batchCode = row[0] || '';
        const batchProductName = (row[1] || '').trim().toUpperCase();
        const firstOrder = parseInt(row[7]) || 0; // Column H (index 7)
        const lastOrder = parseInt(row[8]) || 999999; // Column I (index 8)
        
        // Check if product name matches (flexible - either contains the other)
        const productMatches = productNameClean.includes(batchProductName) || batchProductName.includes(productNameClean);
        
        if (productMatches) {
          console.log('Product match found:', batchProductName, 'Order range:', firstOrder, '-', lastOrder, 'Current order:', orderNumber);
          if (orderNumber >= firstOrder && orderNumber <= lastOrder) {
            matchingBatches.push(batchCode);
            console.log('Batch matched:', batchCode);
          }
        }
      }
      
      if (matchingBatches.length > 0) {
        // Create clickable links for each batch code
        matchingBatches.forEach((batchCode, index) => {
          if (index > 0) {
            tdBatch.appendChild(document.createTextNode(', '));
          }
          const batchLink = document.createElement('a');
          batchLink.href = '#';
          batchLink.style.color = '#e3fc02';
          batchLink.style.textDecoration = 'none';
          batchLink.textContent = batchCode + ' ↗';
          batchLink.onclick = function() {
            // Switch to CHECK BATCH INFO tab
            document.getElementById('tab-batches').click();
            // Set the batch code and search
            document.getElementById('batch-code-input').value = batchCode;
            // Store order number to prefill after search
            window.prefillOrderNumber = orderNumber;
            handleBatchSearch();
            return false;
          };
          tdBatch.appendChild(batchLink);
        });
      } else {
        tdBatch.textContent = 'Batch tracking unavailable for this item';
        tdBatch.style.color = '#999';
        tdBatch.style.fontStyle = 'italic';
      }
      
      tr.appendChild(tdBatch);
      tbody.appendChild(tr);
    });
    
    tableContainer.style.display = 'block';
  });
}

// Early check on DOMContentLoaded (runs before window.load, important for mobile)
document.addEventListener('DOMContentLoaded', () => {
  console.log('=== DOMContentLoaded fired ===');
  const urlParams = new URLSearchParams(window.location.search);
  const batchParam = urlParams.get('batch');
  
  if (batchParam && !pendingBatchSearch) {
    pendingBatchSearch = batchParam.trim();
    console.log('✓ Batch parameter detected in DOMContentLoaded:', pendingBatchSearch);
    
    // Switch to batch tab immediately
    const batchTab = document.getElementById('tab-batches');
    if (batchTab) {
      batchTab.click();
      console.log('✓ Switched to batch tab');
    }
  }
});

window.addEventListener('load', () => {
  console.log('=== Window load event fired ===');
  console.log('Customer logged in:', window.IS_CUSTOMER_LOGGED_IN);
  
  // Initialize storage ONLY if user is logged in (prevents any blocking for anonymous users)
  if (window.IS_CUSTOMER_LOGGED_IN) {
    initializeStorage();
  } else {
    console.log('Skipping storage initialization - user not logged in');
  }
  
  // Load core data immediately
  loadBatchData();
  loadProductsData();
  
  // Load stock tracker items
  if (typeof renderStockTracker === 'function') {
    renderStockTracker();
  }
  
  // Set max date on all date inputs to today
  setMaxDateToToday();
  
  // Setup return button handler
  setupReturnButton();
  
  // Check for tab parameter in URL and switch to that tab
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');
  if (tabParam === 'batches') {
    document.getElementById('tab-batches').click();
  } else if (tabParam === 'products') {
    document.getElementById('tab-products').click();
  }
  
  // Check for batch parameter in URL and auto-search
  function checkBatchParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const batchParam = urlParams.get('batch');
    
    console.log('Checking for batch parameter...');
    console.log('Current URL:', window.location.href);
    console.log('URL params:', window.location.search);
    console.log('Batch param found:', batchParam);
    
    if (batchParam && !pendingBatchSearch) {
      // Make sure we're on the batch search tab
      document.getElementById('tab-batches').click();
      
      // Store batch code for auto-search after data loads
      pendingBatchSearch = batchParam.trim();
      console.log('✓ Batch parameter stored:', pendingBatchSearch, '- will auto-search after data loads');
      return true;
    }
    return false;
  }
  
  // Check immediately
  if (!checkBatchParameter()) {
    // If not found, try again after 500ms (for slow redirects on mobile)
    console.log('Batch parameter not found immediately, will retry in 500ms...');
    setTimeout(() => {
      if (!checkBatchParameter()) {
        console.log('Batch parameter still not found after retry');
      }
    }, 500);
  }
  
  // Add listener for not-purchased checkbox to update save button visibility
  const notPurchasedCb = document.getElementById('not-purchased-checkbox');
  if (notPurchasedCb) {
    notPurchasedCb.addEventListener('change', () => {
      updateSaveButtonVisibility();
    });
  }
  
  // Setup batch search event listeners
  const batchGoBtn = document.getElementById('batch-go-btn');
  const batchInput = document.getElementById('batch-code-input');
  if (batchGoBtn && batchInput) {
    batchGoBtn.addEventListener('click', handleBatchSearch);
    batchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') handleBatchSearch();
    });
  }
});

// Set max date to today on all date inputs
function setMaxDateToToday() {
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0]; // YYYY-MM-DD format
  
  // Set max on purchase date input
  const purchaseDateInput = document.getElementById('purchase-date-input');
  if (purchaseDateInput) {
    purchaseDateInput.setAttribute('max', todayStr);
  }
  
  // Set max on all until-date inputs
  document.querySelectorAll('.until-date-input').forEach(input => {
    input.setAttribute('max', todayStr);
  });
}

// Setup return to batch checker button
function setupReturnButton() {
  const returnBtn = document.getElementById('return-to-batch-checker-btn');
  if (returnBtn) {
    returnBtn.addEventListener('click', () => {
      // Hide batch details
      document.getElementById('batch-details').style.display = 'none';
      // Hide return link
      document.getElementById('return-link').style.display = 'none';
      // Show recent batches
      document.getElementById('recent-batches').style.display = 'block';
      // Clear batch input
      document.getElementById('batch-code-input').value = '';
    });
  }
}

// Setup notification toggle and info box
// Note: StorageAdapter is now loaded from firebase-storage-adapter.js
// It handles Firebase-only storage for logged-in users

// ===================================
// STOCK TRACKER FUNCTIONALITY
// ===================================

// Update link in "My Items" text to point to My Items tab
const goToMyItemsLink = document.getElementById('go-to-my-items');
if (goToMyItemsLink) {
  goToMyItemsLink.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('tab-products').click();
  });
}

// Stock Tracker links
const stockTrackerSearchLink = document.getElementById('stock-tracker-search-link');
const stockTrackerFindLink = document.getElementById('stock-tracker-find-link');

if (stockTrackerSearchLink) {
  stockTrackerSearchLink.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('tab-batches').click();
    document.getElementById('batch-code-input').focus();
  });
}

if (stockTrackerFindLink) {
  stockTrackerFindLink.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('tab-products').click();
    setTimeout(() => {
      if (myBatchesOrderSelect) {
        myBatchesOrderSelect.focus();
        myBatchesOrderSelect.click();
      }
    }, 100);
  });
}

// Save to Stock Tracker button
const saveToTrackerBtn = document.getElementById('save-to-tracker-btn');
const savedToTrackerBtn = document.getElementById('saved-to-tracker-btn');
const savedTrackerLink = document.getElementById('saved-tracker-link');

if (saveToTrackerBtn && savedToTrackerBtn) {
  saveToTrackerBtn.addEventListener('click', async () => {
    // Check if user is logged in
    if (!window.IS_CUSTOMER_LOGGED_IN) {
      alert('Please log in to save items to your Expiry Tracker. This feature requires cross-device sync.');
      return;
    }
    
    // Check if Storage Adapter is initialized
    if (!StorageAdapter.initialized) {
      alert('Unable to connect to storage. Please refresh the page and try again.');
      return;
    }
    
    // Check if user has given consent
    if (!StorageAdapter.hasConsent()) {
      // Show GDPR consent modal
      showGDPRConsentModal(
        async () => {
          // User agreed - record consent and save
          const consentRecorded = await StorageAdapter.recordConsent();
          if (consentRecorded) {
            await executeSaveAction();
          } else {
            alert('Failed to record consent. Please try again.');
          }
        },
        () => {
          // User cancelled - do nothing
          console.log('User declined consent');
        }
      );
    } else {
      // User already gave consent - just save
      await executeSaveAction();
    }
  });
}

// Show GDPR consent modal
function showGDPRConsentModal(onAgree, onCancel) {
  const modal = document.getElementById('gdpr-consent-modal');
  const agreeBtn = document.getElementById('gdpr-agree-btn');
  const cancelBtn = document.getElementById('gdpr-cancel-btn');
  
  if (!modal || !agreeBtn || !cancelBtn) {
    console.error('GDPR modal elements not found');
    return;
  }
  
  // Show modal
  modal.style.display = 'flex';
  
  // Agree button handler
  const agreeHandler = () => {
    modal.style.display = 'none';
    agreeBtn.removeEventListener('click', agreeHandler);
    cancelBtn.removeEventListener('click', cancelHandler);
    onAgree();
  };
  
  // Cancel button handler
  const cancelHandler = () => {
    modal.style.display = 'none';
    agreeBtn.removeEventListener('click', agreeHandler);
    cancelBtn.removeEventListener('click', cancelHandler);
    onCancel();
  };
  
  agreeBtn.addEventListener('click', agreeHandler);
  cancelBtn.addEventListener('click', cancelHandler);
  
  // Close on outside click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      cancelHandler();
    }
  });
}

// Extract save logic into reusable function
async function executeSaveAction() {
  // Gather all the data
  const productName = currentProductName;
  const batchCode = currentMatch[0];
  const dom = currentMatch[2];
  const productImage = document.getElementById('product-image').src;
  const productUrl = document.getElementById('product-link').href || '';
  
  // Get selected storage temp from FIRST section (for Stock Tracker we save primary temp only)
  const firstSection = document.querySelector('.temp-section[data-section="1"]');
  const activeTab = firstSection ? firstSection.querySelector('.storage-method-tab.active') : null;
  if (!activeTab) {
    alert('Please select a storage temperature.');
    return;
  }
  const storageTemp = parseInt(activeTab.getAttribute('data-col'));
  
  // Get purchase date
  const purchaseDate = document.getElementById('purchase-date-input').value;
  const notPurchased = document.getElementById('not-purchased-checkbox').checked;
  
  if (!purchaseDate) {
    alert('Please select an order or enter a purchase date.');
    return;
  }
  
  // Don't allow saving if "not purchased yet" is checked
  if (notPurchased) {
    alert('Please select an order number to save to Expiry Tracker.');
    return;
  }
  
  // Get shipping info
  const selectedOrderOption = document.getElementById('order-number-select').selectedOptions[0];
  const isUK = selectedOrderOption ? (selectedOrderOption.getAttribute('data-country') === 'GB' || selectedOrderOption.getAttribute('data-country') === 'UK') : true;
  
  // Get all temperature sections data
  const tempSections = getTempSectionsData();
  
  // Check if item already exists
  const existingItem = await StorageAdapter.findItemByProduct(productName);
  if (existingItem) {
    // Confirm dialog with Yes/No
    if (!confirm(`You already have one ${productName} saved to your Expiry Tracker. Would you like to overwrite it?`)) {
      // User clicked Cancel (No) - don't overwrite, just add as new
    } else {
      // User clicked OK (Yes) - delete existing before adding
      await StorageAdapter.deleteItem(existingItem.id);
    }
  }
  
  // Create item object
  const item = {
    id: Date.now() + Math.random(), // Unique ID
    productName,
    batchCode,
    dom,
    productImage,
    productUrl,
    storageTemp,
    purchaseDate,
    isUK,
    tempSections, // Save all temperature sections
    savedAt: new Date().toISOString()
  };
  
  // Save to storage
  await StorageAdapter.saveItem(item);
  
  // Show saved state (no alert)
  showSavedState();
  
  // Auto-redirect to Expiry Tracker tab
  setTimeout(() => {
    document.getElementById('tab-products').click();
  }, 500);
    
  // Refresh stock tracker display if on My Items tab
  if (document.getElementById('products').classList.contains('active')) {
    renderStockTracker();
  }
}

// Show saved state button
function showSavedState() {
  saveToTrackerBtn.style.display = 'none';
  savedToTrackerBtn.style.display = 'block';
  savedTrackerLink.style.display = 'block';
}

// Show unsaved state - revert button
function showUnsavedState() {
  if (saveToTrackerBtn && savedToTrackerBtn && savedTrackerLink) {
    saveToTrackerBtn.style.display = 'block';
    savedToTrackerBtn.style.display = 'none';
    savedTrackerLink.style.display = 'none';
  }
}

// Attach listeners to revert saved state when inputs change
function attachInputChangeListeners() {
  const orderSelect = document.getElementById('order-number-select');
  const storageTabs = document.querySelectorAll('.storage-method-tab');
  
  if (orderSelect) {
    orderSelect.addEventListener('change', showUnsavedState);
  }
  
  storageTabs.forEach(tab => {
    tab.addEventListener('click', showUnsavedState);
  });
}

// Link from saved state to My Items
const goToSavedItems = document.getElementById('go-to-saved-items');
if (goToSavedItems) {
  goToSavedItems.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('tab-products').click();
  });
}

// Watch for changes that should revert the button state
if (orderNumberSelect) {
  orderNumberSelect.addEventListener('change', showUnsavedState);
}

if (notPurchasedCheckbox) {
  notPurchasedCheckbox.addEventListener('change', showUnsavedState);
}

// Note: Storage tab change listeners are now handled in setupTempSectionListeners()

// Render Stock Tracker items
async function renderStockTracker() {
  const container = document.getElementById('stock-tracker-items');
  const emptyMessage = document.getElementById('stock-tracker-empty');
  
  if (!container) return;
  
  // Skip if user is not logged in (no storage access needed)
  if (!window.IS_CUSTOMER_LOGGED_IN) {
    console.log('Skipping stock tracker render - user not logged in');
    return;
  }
  
  // Ensure data is loaded before rendering
  if (!batchData || batchData.length === 0) {
    await loadBatchData();
  }
  if (!productsData || productsData.length === 0) {
    await loadProductsData();
  }
  
  try {
    const items = await StorageAdapter.getAllItems();
    
    if (items.length === 0) {
      container.innerHTML = '';
      emptyMessage.textContent = 'No saved items yet.';
      emptyMessage.style.display = 'block';
      return;
    }
  } catch (error) {
    console.error('Error loading stock tracker items:', error);
    return;
  }
  
  emptyMessage.style.display = 'none';
  container.innerHTML = '';
  
  items.forEach(item => {
    const itemDiv = createStockTrackerItem(item);
    container.appendChild(itemDiv);
    
    // Add scroll hint below each item (only visible in mobile portrait)
    const scrollHint = document.createElement('div');
    scrollHint.className = 'stock-tracker-scroll-hint';
    scrollHint.textContent = 'SCROLL ↔';
    container.appendChild(scrollHint);
  });
}

// Create a stock tracker item element
function createStockTrackerItem(item) {
  // Calculate DTE
  const dteData = calculateDTE(item);
  
  // Get the most recent storage temp
  let currentStorageTemp = item.storageTemp; // Default to main storage temp
  if (item.tempSections && item.tempSections.length > 0) {
    // Get the last section's temperature (most recent)
    const lastSection = item.tempSections[item.tempSections.length - 1];
    currentStorageTemp = lastSection.colIndex;
  }
  
  const div = document.createElement('div');
  div.className = 'stock-tracker-item';
  
  // Image (linked to product page)
  const imgLink = document.createElement('a');
  imgLink.href = item.productUrl || '#';
  imgLink.target = item.productUrl ? '_blank' : '_self';
  imgLink.style.display = 'block';
  imgLink.style.width = '80px';
  imgLink.style.height = '80px';
  imgLink.style.flexShrink = '0';
  
  const img = document.createElement('img');
  img.src = item.productImage || '';
  img.className = 'stock-tracker-image';
  img.alt = item.productName;
  
  imgLink.appendChild(img);
  
  // Info section
  const info = document.createElement('div');
  info.className = 'stock-tracker-info';
  
  // Product name (linked to product page)
  const nameLink = document.createElement('a');
  nameLink.href = item.productUrl || '#';
  nameLink.target = item.productUrl ? '_blank' : '_self';
  nameLink.className = 'stock-tracker-product-name';
  nameLink.textContent = item.productName;
  nameLink.style.textDecoration = 'none';
  nameLink.style.color = 'white';
  
  const batch = document.createElement('a');
  batch.className = 'stock-tracker-batch';
  batch.textContent = item.batchCode;
  batch.href = '#';
  batch.onclick = (e) => {
    e.preventDefault();
    document.getElementById('tab-batches').click();
    document.getElementById('batch-code-input').value = item.batchCode;
    handleBatchSearch();
  };
  
  info.appendChild(nameLink);
  info.appendChild(batch);
  
  // Current Storage Box
  const storage = document.createElement('div');
  storage.className = 'stock-tracker-storage';
  
  const storageTitle = document.createElement('div');
  storageTitle.className = 'stock-tracker-storage-title';
  storageTitle.textContent = 'CURRENT STORAGE';
  
  const storageTemp = document.createElement('div');
  storageTemp.className = 'stock-tracker-storage-temp';
  storageTemp.textContent = getTempName(currentStorageTemp);
  
  // Color code based on temp
  if (currentStorageTemp === 6) {
    storageTemp.style.color = '#b3e7f4'; // Frozen
  } else if (currentStorageTemp === 5) {
    storageTemp.style.color = '#F0F8FE'; // Refrigerated
  } else {
    storageTemp.style.color = '#FFA756'; // Ambient
  }
  
  storage.appendChild(storageTitle);
  storage.appendChild(storageTemp);
  
  // DTE Box - new layout with title at bottom
  const dte = document.createElement('div');
  dte.className = 'stock-tracker-dte';
  
  const dteDays = document.createElement('div');
  dteDays.className = 'stock-tracker-dte-days';
  dteDays.textContent = dteData.days;
  dteDays.style.color = dteData.color;
  
  dte.appendChild(dteDays);
  
  // Only show "DAYS TO EXPIRY" if not expired
  if (dteData.days !== 'EXP' && dteData.days !== 0) {
    const dteTitle = document.createElement('div');
    dteTitle.className = 'stock-tracker-dte-title';
    dteTitle.textContent = 'DAYS TO EXPIRY';
    dte.appendChild(dteTitle);
  }
  
  // Edit button
  const editBtn = document.createElement('div');
  editBtn.className = 'stock-tracker-edit';
  editBtn.innerHTML = `
    <div style="text-align: center;">
      <div style="font-size: 10px; color: #999; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.5px;">Edit</div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>
      </svg>
    </div>
  `;
  editBtn.onclick = () => {
    loadItemForEditing(item);
  };
  
  // Delete button
  const deleteBtn = document.createElement('div');
  deleteBtn.className = 'stock-tracker-delete';
  deleteBtn.innerHTML = `
    <div style="text-align: center;">
      <div style="font-size: 10px; color: #999; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.5px;">Remove</div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
      </svg>
    </div>
  `;
  deleteBtn.onclick = async () => {
    await StorageAdapter.deleteItem(item.id);
    renderStockTracker();
  };
  
  div.appendChild(imgLink);
  div.appendChild(info);
  div.appendChild(storage);
  div.appendChild(dte);
  div.appendChild(editBtn);
  div.appendChild(deleteBtn);
  
  return div;
}

// Load an item for editing
function loadItemForEditing(item) {
  // Scroll to top of page so tabs are visible
  window.scrollTo(0, 0);
  
  // Switch to batch info tab
  document.getElementById('tab-batches').click();
  
  // Set batch code and search
  document.getElementById('batch-code-input').value = item.batchCode;
  
  // Store the item being edited for later
  window.editingItem = item;
  
  // Trigger search
  handleBatchSearch();
  
  // After search completes, prefill the order and temp sections
  setTimeout(() => {
    // Try to select the order by date
    const orderSelect = document.getElementById('order-number-select');
    if (orderSelect && item.purchaseDate) {
      const options = orderSelect.querySelectorAll('option');
      for (let option of options) {
        if (option.value === item.purchaseDate) {
          orderSelect.value = option.value;
          // Trigger change event
          orderSelect.dispatchEvent(new Event('change'));
          break;
        }
      }
    }
    
    // Set purchase date
    const purchaseDateInput = document.getElementById('purchase-date-input');
    if (purchaseDateInput && item.purchaseDate) {
      purchaseDateInput.value = item.purchaseDate;
    }
    
    // Show storage tabs
    const storageTabsContainer = document.getElementById('storage-tabs-container');
    if (storageTabsContainer) {
      storageTabsContainer.style.display = 'block';
    }
    
    // Rebuild temp sections from saved data
    if (item.tempSections && item.tempSections.length > 0) {
      rebuildTempSections(item.tempSections);
    }
    
    // Update expiry display
    checkAndShowExpiryBar();
  }, 500);
}

// Rebuild temperature sections from saved item data
function rebuildTempSections(tempSections) {
  const container = document.getElementById('temp-sections-container');
  if (!container || !tempSections || tempSections.length === 0) return;
  
  // Clear existing sections beyond the first one
  const existingSections = container.querySelectorAll('.temp-section');
  existingSections.forEach((section, index) => {
    if (index > 0) section.remove();
  });
  
  // Configure first section
  const firstSection = container.querySelector('.temp-section[data-section="1"]');
  if (firstSection && tempSections[0]) {
    const firstTempData = tempSections[0];
    
    // Select the correct temp tab
    firstSection.querySelectorAll('.storage-method-tab').forEach(tab => {
      tab.classList.remove('active');
      if (parseInt(tab.getAttribute('data-col')) === firstTempData.colIndex) {
        tab.classList.add('active');
      }
    });
    
    // Set until now / until date
    const untilNowCheckbox = firstSection.querySelector('.until-now-checkbox');
    const untilDateContainer = firstSection.querySelector('.until-date-container');
    const untilDateInput = firstSection.querySelector('.until-date-input');
    
    if (untilNowCheckbox) {
      untilNowCheckbox.checked = firstTempData.untilNow;
    }
    
    if (untilDateContainer && untilDateInput) {
      if (!firstTempData.untilNow && firstTempData.untilDate) {
        untilDateContainer.style.display = 'flex';
        untilDateInput.value = firstTempData.untilDate;
      } else {
        untilDateContainer.style.display = 'none';
      }
    }
  }
  
  // Add additional sections if needed
  for (let i = 1; i < tempSections.length; i++) {
    const sectionData = tempSections[i];
    const sectionNum = i + 1;
    addTempSection(sectionNum); // This will add a new section
    
    // Use setTimeout to ensure DOM is updated before selecting tabs
    (function(sectionData, sectionNum) {
      setTimeout(() => {
        // Configure the newly added section
        const newSection = container.querySelector(`.temp-section[data-section="${sectionNum}"]`);
        if (newSection) {
          // Select the correct temp tab
          newSection.querySelectorAll('.storage-method-tab').forEach(tab => {
            tab.classList.remove('active');
            if (parseInt(tab.getAttribute('data-col')) === sectionData.colIndex) {
              tab.classList.add('active');
            }
          });
          
          // Set until now / until date
          const untilNowCheckbox = newSection.querySelector('.until-now-checkbox');
          const untilDateContainer = newSection.querySelector('.until-date-container');
          const untilDateInput = newSection.querySelector('.until-date-input');
          
          if (untilNowCheckbox) {
            untilNowCheckbox.checked = sectionData.untilNow;
          }
          
          if (untilDateContainer && untilDateInput) {
            if (!sectionData.untilNow && sectionData.untilDate) {
              untilDateContainer.style.display = 'flex';
              untilDateInput.value = sectionData.untilDate;
            } else {
              untilDateContainer.style.display = 'none';
            }
          }
        }
      }, 50 * (sectionNum - 1)); // Stagger timeouts for multiple sections
    })(sectionData, sectionNum);
  }
  
  // After all sections are configured, trigger a full recalculation
  const totalDelay = 50 * tempSections.length + 100;
  setTimeout(() => {
    updateExpiryDisplay();
    updateSaveButtonVisibility();
  }, totalDelay);
}

// Calculate DTE for a saved item
// Calculate DTE for a saved item - matches updateExpiryDisplay logic
function calculateDTE(item) {
  console.log('Calculating DTE for:', item.productName, 'Batch:', item.batchCode);
  
  // Check if data is loaded
  if (!batchData || batchData.length === 0 || !productsData || productsData.length === 0) {
    console.log('Data not loaded');
    return { days: '?', color: '#999' };
  }
  
  // Find the batch data row
  const batchRow = batchData.find(row => row[0] && row[0].toUpperCase() === item.batchCode.toUpperCase());
  if (!batchRow) {
    console.log('Batch not found:', item.batchCode);
    return { days: '?', color: '#999' };
  }
  
  // Get product data for pre-sale temp
  const productMatch = productsData.find(row => row[0] && row[0].toUpperCase() === item.productName.toUpperCase());
  const preSaleTemp = productMatch ? parseInt(productMatch[1]) : 21;
  const preCol = getTempCol(preSaleTemp);
  const ambientCol = 4;
  const colIndex = item.storageTemp; // Customer storage temp column
  
  // Parse dates from batch row
  const domDate = parseDate(batchRow[2]);
  const shelfPreExpiry = parseDate(batchRow[preCol]);
  const shelfAmbientExpiry = parseDate(batchRow[ambientCol]);
  const shelfCustomerExpiry = parseDate(batchRow[colIndex]);
  
  if (!domDate || !shelfPreExpiry || !shelfAmbientExpiry || !shelfCustomerExpiry) {
    console.log('Invalid dates in batch row');
    return { days: '?', color: '#999' };
  }
  
  // Calculate shelf life in days
  const shelfPreDays = calculateDaysBetween(domDate, shelfPreExpiry);
  const shelfAmbientDays = calculateDaysBetween(domDate, shelfAmbientExpiry);
  const shelfCustomerDays = calculateDaysBetween(domDate, shelfCustomerExpiry);
  
  // Parse purchase date (YYYY-MM-DD format)
  const purchaseDateParts = item.purchaseDate.split('-');
  const purchaseDate = new Date(purchaseDateParts[0], purchaseDateParts[1] - 1, purchaseDateParts[2]);
  purchaseDate.setHours(0, 0, 0, 0);
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // Calculate degradation
  let degradedPre = 0;
  let degradedShip = 0;
  let degradedSince = 0;
  
  // Pre-dispatch: manufacture to purchase
  const daysPre = calculateDaysBetween(domDate, purchaseDate);
  degradedPre = shelfPreDays > 0 ? daysPre / shelfPreDays : 0;
  
  // Shipping degradation
  const shippingDaysFull = item.isUK ? 2 : 6;
  const arrivalDate = new Date(purchaseDate);
  arrivalDate.setDate(arrivalDate.getDate() + shippingDaysFull);
  
  let degradedSections = [];
  
  if (today < arrivalDate) {
    // Still in transit
    const daysShip = calculateDaysBetween(purchaseDate, today);
    degradedShip = shelfAmbientDays > 0 ? daysShip / shelfAmbientDays : 0;
  } else {
    // Delivered
    degradedShip = shelfAmbientDays > 0 ? shippingDaysFull / shelfAmbientDays : 0;
    
    // Use tempSections if available, otherwise fall back to single storage temp
    if (item.tempSections && item.tempSections.length > 0) {
      // Multi-section temperature tracking
      let sectionStartDate = new Date(arrivalDate);
      
      for (let i = 0; i < item.tempSections.length; i++) {
        const section = item.tempSections[i];
        const shelfDaysForTemp = calculateDaysBetween(domDate, parseDate(batchRow[section.colIndex]));
        
        let sectionEndDate;
        if (section.untilNow || !section.untilDate) {
          sectionEndDate = new Date(today);
        } else {
          const parts = section.untilDate.split('-');
          sectionEndDate = new Date(parts[0], parts[1] - 1, parts[2]);
          sectionEndDate.setHours(0, 0, 0, 0);
          
          if (sectionEndDate > today) {
            sectionEndDate = new Date(today);
          }
        }
        
        const sectionDays = calculateDaysBetween(sectionStartDate, sectionEndDate);
        const sectionDegraded = shelfDaysForTemp > 0 ? sectionDays / shelfDaysForTemp : 0;
        
        degradedSections.push(sectionDegraded);
        
        sectionStartDate = new Date(sectionEndDate);
        
        if (section.untilNow || !section.untilDate || sectionEndDate.getTime() === today.getTime()) {
          break;
        }
      }
    } else {
      // Single temperature (backward compatibility)
      const shelfCustomerExpiry = parseDate(batchRow[colIndex]);
      const shelfCustomerDays = calculateDaysBetween(domDate, shelfCustomerExpiry);
      const daysSince = calculateDaysBetween(arrivalDate, today);
      degradedSections.push(shelfCustomerDays > 0 ? daysSince / shelfCustomerDays : 0);
    }
  }
  
  const totalSectionsDegraded = degradedSections.reduce((sum, d) => sum + d, 0);
  const totalDegraded = degradedPre + degradedShip + totalSectionsDegraded;
  const expiredPercent = Math.min(100, totalDegraded * 100);
  
  console.log('Total degraded:', totalDegraded, 'Expired %:', expiredPercent);
  
  // Check if expired
  if (totalDegraded >= 1) {
    return { days: 'EXP', color: '#dc2626' };
  }
  
  // Calculate remaining days using the final section's temperature shelf life
  let finalShelfDays;
  if (item.tempSections && item.tempSections.length > 0) {
    const lastSection = item.tempSections[item.tempSections.length - 1];
    finalShelfDays = calculateDaysBetween(domDate, parseDate(batchRow[lastSection.colIndex]));
  } else {
    finalShelfDays = shelfCustomerDays;
  }
  
  const remainingDegraded = Math.max(0, 1 - totalDegraded);
  const remainingDays = Math.floor(remainingDegraded * finalShelfDays);
  const color = getColorForPercent(expiredPercent);
  
  return { days: remainingDays, color };
}

// Get temp name from column index
function getTempName(colIndex) {
  if (colIndex === 6) return '-18°C';
  if (colIndex === 5) return '5°C';
  if (colIndex === 4) return '21°C';
  return '?';
}

// Show/hide save button based on expiry bar visibility and order selection
function updateSaveButtonVisibility() {
  const expiryBar = document.getElementById('expiry-bar-container');
  const saveBtn = document.getElementById('save-to-tracker-btn');
  const savedBtn = document.getElementById('saved-to-tracker-btn');
  const notPurchasedCheckbox = document.getElementById('not-purchased-checkbox');
  const orderSelect = document.getElementById('order-number-select');
  const savedTrackerLink = document.getElementById('saved-tracker-link');
  
  if (!expiryBar || !saveBtn || !savedBtn || !savedTrackerLink) return;
  
  const isExpiryVisible = expiryBar.style.display !== 'none' && window.getComputedStyle(expiryBar).display !== 'none';
  const isNotPurchased = notPurchasedCheckbox && notPurchasedCheckbox.checked;
  const hasOrderSelected = orderSelect && orderSelect.value !== '' && !orderSelect.disabled;
  
  // Check if all temp sections are properly filled
  const allSectionsValid = validateAllTempSections();
  
  // Hide save button if "not purchased yet" is checked - this takes priority
  if (isNotPurchased) {
    saveBtn.style.display = 'none';
    savedBtn.style.display = 'none';
    savedTrackerLink.style.display = 'none';
    return;
  }
  
  // Only show save button if: expiry bar visible, order selected, and all sections valid
  if (isExpiryVisible && hasOrderSelected && allSectionsValid) {
    // Show whichever button state is appropriate
    if (savedBtn.style.display === 'block') {
      // Already in saved state, keep it
    } else {
      saveBtn.style.display = 'block';
    }
  } else {
    saveBtn.style.display = 'none';
    savedBtn.style.display = 'none';
    savedTrackerLink.style.display = 'none';
  }
}

// Validate that all temperature sections have required data
function validateAllTempSections() {
  const allSections = document.querySelectorAll('.temp-section');
  
  for (const section of allSections) {
    const activeTab = section.querySelector('.storage-method-tab.active');
    const untilNowCheckbox = section.querySelector('.until-now-checkbox');
    const untilDateInput = section.querySelector('.until-date-input');
    
    // Must have a temperature selected
    if (!activeTab) {
      return false;
    }
    
    // If "until now" is unchecked, must have a valid date
    if (untilNowCheckbox && !untilNowCheckbox.checked) {
      if (!untilDateInput || !untilDateInput.value) {
        return false;
      }
    }
  }
  
  return true;
}

// ==========================================
// IMMEDIATE BATCH PARAMETER CHECK (runs before window.load)
// ==========================================
(function() {
  console.log('=== IMMEDIATE BATCH CHECK (script load) ===');
  console.log('Current URL:', window.location.href);
  const urlParams = new URLSearchParams(window.location.search);
  const batchParam = urlParams.get('batch');
  console.log('Batch parameter:', batchParam);
  
  if (batchParam) {
    pendingBatchSearch = batchParam.trim();
    console.log('✓ Batch parameter stored early:', pendingBatchSearch);
  }
})();